import {
  SAVE_FILE_DISCOUNTS,
  SAVE_FILE_DISCOUNTS_SUCCESS,
  SAVE_FILE_DISCOUNTS_ERROR,
  GET_CLIENT_DISCOUNTS,
  GET_CLIENT_DISCOUNTS_SUCCESS,
  GET_CLIENT_DISCOUNTS_ERROR,
  CLEAR_CLIENT_DISCOUNTS,
  SEARCH_DISCOUNT_ITEMS,
  SEARCH_DISCOUNT_ITEMS_SUCCESS,
  SEARCH_DISCOUNT_ITEMS_ERROR,
  SUBMIT_DISCOUNT_REQUEST,
  SUBMIT_DISCOUNT_REQUEST_SUCCESS,
  SUBMIT_DISCOUNT_REQUEST_ERROR,
  RESET_SUBMIT_DISCOUNT_SUCCESS,
  GET_AVAILABLE_TARGETS,
  GET_AVAILABLE_TARGETS_SUCCESS,
  GET_AVAILABLE_TARGETS_ERROR,
} from '../constants/ActionsTypes'

const initialState = {
  discounts_success: false,
  discounts_error: false,
  clientDiscounts: {
    data: [],
    metadata: null,
  },
  clientDiscountsLoading: false,
  clientDiscountsError: null,
  searchResults: [],
  searchLoading: false,
  searchError: null,
  searchDiscountItemsResult: [],
  searchDiscountItemsLoading: false,
  searchDiscountItemsError: null,
  submitLoading: false,
  submitError: null,
  submitSuccess: false,
  availableTargets: [],
  availableTargetsLoading: false,
  availableTargetsError: null,
}

function rootReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_FILE_DISCOUNTS:
      return { ...state, discounts_success: false, discounts_error: false }
    case SAVE_FILE_DISCOUNTS_SUCCESS:
      return { ...state, discounts_success: true }
    case SAVE_FILE_DISCOUNTS_ERROR: {
      return { ...state, discounts_error: true }
    }
    case GET_CLIENT_DISCOUNTS:
      return {
        ...state,
        clientDiscountsLoading: true,
        clientDiscountsError: null,
      }
    case GET_CLIENT_DISCOUNTS_SUCCESS:
      return {
        ...state,
        clientDiscounts: {
          data: action.payload.data || [],
          metadata: action.payload.metadata || null,
        },
        clientDiscountsLoading: false,
        clientDiscountsError: null,
      }
    case GET_CLIENT_DISCOUNTS_ERROR:
      return {
        ...state,
        clientDiscountsLoading: false,
        clientDiscountsError: action.payload,
      }
    case CLEAR_CLIENT_DISCOUNTS:
      return {
        ...state,
        clientDiscounts: {
          data: [],
          metadata: null,
        },
        clientDiscountsLoading: false,
        clientDiscountsError: null,
      }
    case SEARCH_DISCOUNT_ITEMS:
      return {
        ...state,
        searchDiscountItemsLoading: true,
        searchDiscountItemsError: null,
      }
    case SEARCH_DISCOUNT_ITEMS_SUCCESS:
      return {
        ...state,
        searchDiscountItemsResult: action.payload,
        searchDiscountItemsLoading: false,
        searchDiscountItemsError: null,
      }
    case SEARCH_DISCOUNT_ITEMS_ERROR:
      return {
        ...state,
        searchDiscountItemsResult: [],
        searchDiscountItemsLoading: false,
        searchDiscountItemsError: action.payload,
      }
    case SUBMIT_DISCOUNT_REQUEST:
      return {
        ...state,
        submitLoading: true,
        submitError: null,
        submitSuccess: false,
      }
    case SUBMIT_DISCOUNT_REQUEST_SUCCESS:
      return {
        ...state,
        submitLoading: false,
        submitError: null,
        submitSuccess: true,
      }
    case SUBMIT_DISCOUNT_REQUEST_ERROR:
      return {
        ...state,
        submitLoading: false,
        submitError: action.payload,
        submitSuccess: false,
      }
    case RESET_SUBMIT_DISCOUNT_SUCCESS:
      return {
        ...state,
        submitSuccess: false,
        submitError: null,
      }
    case GET_AVAILABLE_TARGETS:
      return {
        ...state,
        availableTargetsLoading: true,
        availableTargetsError: null,
      }
    case GET_AVAILABLE_TARGETS_SUCCESS:
      return {
        ...state,
        availableTargets: action.payload.items,
        availableTargetsLoading: false,
        availableTargetsError: null,
      }
    case GET_AVAILABLE_TARGETS_ERROR:
      return {
        ...state,
        availableTargetsLoading: false,
        availableTargetsError: action.payload,
      }
    default:
      return state
  }
}

export default rootReducer
